import { render } from "./main.vue?vue&type=template&id=71898892&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=71898892&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71898892"]])

export default __exports__